export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";